const SpeedGuide = () => {
  return (
    <div className="glass-card rounded-2xl p-6 bg-white dark:bg-gray-800 border border-[#1E9B4C]/20 dark:border-green-500/20">
      <h3 className="font-bold text-lg mb-4 text-[#1E9B4C] dark:text-green-400">Speed Guide</h3>
      <div className="space-y-3 text-sm">
        <div className="flex justify-between">
          <span className="text-gray-600 dark:text-gray-400">Streaming HD:</span>
          <span className="text-[#1E9B4C] dark:text-green-400">5+ Mbps</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600 dark:text-gray-400">Video Calls:</span>
          <span className="text-[#1E9B4C] dark:text-green-400">10+ Mbps</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600 dark:text-gray-400">Gaming:</span>
          <span className="text-[#1E9B4C] dark:text-green-400">25+ Mbps</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-600 dark:text-gray-400">4K Streaming:</span>
          <span className="text-[#1E9B4C] dark:text-green-400">50+ Mbps</span>
        </div>
      </div>
    </div>
  );
};
export default SpeedGuide;